import $ from 'jquery';
import { standardAjaxPost } from 'stdjs/standard-ajax';
import { displayMessages, destroyMessages } from 'stdjs/validation';
import { confirmModel } from 'stdjs/confirm-model';

export function deleteModel(url, modelIdName, modelId, successCallback, stayOnPage, domPrefix, extraMessage = "", extraData = {}){

    destroyMessages();

    if (typeof domPrefix === "undefined"){
        domPrefix = "";
    }
    
    if ( typeof stayOnPage === "undefined" ){
        stayOnPage = true;
    }
    
    if ( extraMessage ){
        extraMessage = " " + extraMessage;
    }
    
    var dialogId = "DELETEMODAL";
    var submitButtonId = "deleteModelDelete";
    var cancelButtonId = "deleteModelCancel";

    var oDiv = document.createElement("div");
    oDiv.setAttribute("id", dialogId);
    oDiv.setAttribute("tab-index", -1);
    oDiv.setAttribute("role", "dialog");
    $(oDiv).addClass("modal");
    $(oDiv).addClass("fade");
    oDiv = $(oDiv);
    
    $("body").append(oDiv);
    
    oDiv.html("\
            <div class=\"modal-dialog detail-modal row no-gutters modal-dialog-center modal-dialog-height-to-content\" role=\"document\">\
                <div class=\"modal-content col-12 col-md-3\">\
                    <div class=\"modal-header  card-header\">\
                        <div class=\"row no-gutters w-100\">\
                            <div class=\"col-12 text-sm-center text-lg-left\">\
                                <div class=\"d-flex\">\
                                    <span class=\"card-header-title flex-grow-1\">Are you sure you wish to delete?</span>\
                                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\
                                        <span aria-hidden=\"true\">&times;</span>\
                                    </button>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                    <div class=\"modal-body card-body\">\
                        <div class=\"row\">\
                            <div class=\"col\">\
                                <div class=\"\">\
                                    If you choose to continue this operation cannot be reversed." + extraMessage + "\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                    <div class=\"modal-footer justify-content-around\">\
                        <button id=\"" + cancelButtonId + "\" class=\"btn stdButton\">Cancel</button>\
                        <button id=\"" + submitButtonId + "\" class=\"btn stdButton\">Delete</button>\
                    </div>\
                </div>\
            </div>\
    ");

    oDiv.modal( 'show' );
    oDiv.on("hidden.bs.modal", function(e){
        oDiv.modal("hide").remove();
    });
    
    var $submitButton = $(domPrefix + "#" + submitButtonId);
    var $cancelButton = $(domPrefix + "#" + cancelButtonId);

    $cancelButton.click(function(event) {
        oDiv.modal("hide");
    });

    $submitButton.click(function(event) {

        var data = modelIdName + "=" + modelId;

        if (typeof stayOnPage !== "undefined" && stayOnPage){
            data += "&*STAY_ON_PAGE=1"
        } 
        
        if (Object.keys( extraData ).length ){
            data += "&" + $.param( extraData );
        }

        var modifiedSuccessCallback = function(data){
            oDiv.on("hidden.bs.modal", function(e){
                oDiv.modal("hide").remove();
                successCallback(data);               
            });        
            oDiv.modal("hide");
        }

        var errorCallback = function(data){
            displayMessages(data.errorMessages, data.warningMessages, data.infoMessages);
            oDiv.modal("hide");
        }

        standardAjaxPost(url, data, modifiedSuccessCallback, errorCallback);

    });

}

export function deleteModelData(url, data, successCallback, stayOnPage, domPrefix, extraMessage = "", extraData = {}){

    destroyMessages();

    if (typeof domPrefix === "undefined"){
        domPrefix = "";
    }
    
    if ( typeof stayOnPage === "undefined" ){
        stayOnPage = true;
    }
    
    if ( extraMessage ){
        extraMessage = " " + extraMessage;
    }
    
    var dialogId = "DELETEMODAL";
    var submitButtonId = "deleteModelDelete";
    var cancelButtonId = "deleteModelCancel";

    var oDiv = document.createElement("div");
    oDiv.setAttribute("id", dialogId);
    oDiv.setAttribute("tab-index", -1);
    oDiv.setAttribute("role", "dialog");
    $(oDiv).addClass("modal");
    $(oDiv).addClass("fade");
    oDiv = $(oDiv);
    
    $("body").append(oDiv);
    
    oDiv.html("\
            <div class=\"modal-dialog detail-modal row no-gutters modal-dialog-center modal-dialog-height-to-content\" role=\"document\">\
                <div class=\"modal-content col-12 col-md-3\">\
                    <div class=\"modal-header  card-header\">\
                        <div class=\"row no-gutters w-100\">\
                            <div class=\"col-12 text-sm-center text-lg-left\">\
                                <div class=\"d-flex\">\
                                    <span class=\"card-header-title flex-grow-1\">Are you sure you wish to delete?</span>\
                                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\
                                        <span aria-hidden=\"true\">&times;</span>\
                                    </button>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                    <div class=\"modal-body card-body\">\
                        <div class=\"row\">\
                            <div class=\"col\">\
                                <div class=\"\">\
                                    If you choose to continue this operation cannot be reversed." + extraMessage + "\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                    <div class=\"modal-footer justify-content-around\">\
                        <button id=\"" + cancelButtonId + "\" class=\"btn stdButton\">Cancel</button>\
                        <button id=\"" + submitButtonId + "\" class=\"btn stdButton\">Delete</button>\
                    </div>\
                </div>\
            </div>\
    ");

    oDiv.modal( 'show' );
    oDiv.on("hidden.bs.modal", function(e){
        oDiv.modal("hide").remove();
    });
    
    var $submitButton = $(domPrefix + "#" + submitButtonId);
    var $cancelButton = $(domPrefix + "#" + cancelButtonId);

    $cancelButton.click(function(event) {
        oDiv.modal("hide");
    });

    $submitButton.click(function(event) {

        if (typeof stayOnPage !== "undefined" && stayOnPage){
            data += "&*STAY_ON_PAGE=1"
        } 
        
        if (Object.keys( extraData ).length ){
            data += "&" + $.param( extraData );
        }

        var modifiedSuccessCallback = function(data){
            oDiv.on("hidden.bs.modal", function(e){
                oDiv.modal("hide").remove();
                successCallback(data);               
            });        
            oDiv.modal("hide");
        }

        var errorCallback = function(data){
            displayMessages(data.errorMessages, data.warningMessages, data.infoMessages);
            oDiv.modal("hide");
        }

        standardAjaxPost(url, data, modifiedSuccessCallback, errorCallback);

    });

}